<template>
  <v-row>
    <v-row v-if="loading">
      <v-progress-circular
        :size="55"
        :width="4"
        indeterminate
        color="primary"
        class="my-12 mx-auto"
        max-width="500px"
      ></v-progress-circular>
    </v-row>

    <v-card-text v-if="!loading">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title class="subtitle-1">{{
              $t("components.details.serviceDetails.boat")
            }}</v-card-title>
            <v-card-subtitle>
              {{ editedItem.crm_boat.model.brand_name }}
              <span v-if="editedItem.crm_boat.model.model">
                {{ editedItem.crm_boat.model.model }}
              </span>
              <span v-if="editedItem.crm_boat.slot_number">
                #{{ editedItem.crm_boat.slot_number }}
              </span>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title class="subtitle-1">{{
              $t("components.details.serviceDetails.boatPart")
            }}</v-card-title>
            <v-card-subtitle
              v-if="
                typeof editedItem.crm_boat_item.crm_item.formatted_name !==
                'undefined'
              "
            >
              {{ editedItem.crm_boat_item.crm_item.formatted_name }}
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title class="subtitle-1">{{
              $t("components.details.serviceDetails.shortDescription")
            }}</v-card-title>
            <v-card-subtitle>
              {{ editedItem.crm_service.short_task }}
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title class="subtitle-1">{{
              $t("components.details.serviceDetails.intervals")
            }}</v-card-title>
            <v-card-subtitle
              v-for="(interval, ind) in editedItem.crm_service.intervals"
              :key="ind"
            >
              {{ intervalString(interval) }}
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title class="subtitle-1">{{
              $t("components.details.serviceDetails.serviceInstructionsList")
            }}</v-card-title>

            <v-row
              class="mx-4"
              no-gutters
              v-for="(subtask, ind) in editedItem.crm_service.subtasks"
              :key="ind"
            >
              <v-col cols="10" class="mt-0 pt-0 pb-0 mb-0">
                <v-checkbox
                  v-model="subtask.completed"
                  color="primary"
                  :label="subtask.description"
                  disabled
                  class="mt-0 pt-0 pb-0 mb-0"
                ></v-checkbox
              ></v-col>
              <v-row no-gutters>
                <v-col cols="9" class="ml-8">
                  <v-textarea
                    class="pt-0 mt-0 pb-0 mb-0"
                    color="primary"
                    v-if="subtask.active"
                    v-model="subtask.comment"
                    rows="1"
                    label="Comment"
                    auto-grow
                    @change="saveSubtask('comment', subtask)"
                    :disabled="disabled"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-row>
</template>

<script>
import api from "@/utils/api.js";

export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  components: {},
  data: () => ({
    loading: false,
    editedItem: {},
  }),

  computed: {},

  created() {
    if (this.dialog.action === "maintenance") {
      this.loadTaskDetils();
    } else {
      console.error("SERVICE DETAILS: Action is correct");
    }
  },

  methods: {
    loadTaskDetils() {
      this.loading = true;
      api.getService(this.dialog.details.uuid).then((resp) => {
        this.editedItem = resp.data;
        this.loading = false;
      });
    },

    intervalString(interval) {
      let source, periodic, postfix;
      if (interval.source === "MANUAL")
        return this.$t("builder.parts.details.custom");

      if (interval.source === "ITEM_AGE_MONTHS")
        source = this.$t("builder.parts.details.itemAge");
      else if (interval.source === "ENGINE_HOURS")
        source = this.$t("builder.parts.details.engineHours");
      else if (interval.source === "MILEAGE")
        source = this.$t("builder.parts.details.boatMileage");
      else if (interval.source === "SAILING_HOURS")
        source = this.$t("builder.parts.details.sailingHours");
      else if (interval.source === "RUNNING_HOURS")
        source = this.$t("builder.parts.details.runningHours");

      if (interval.periodic) periodic = this.$t("builder.parts.details.every");
      else periodic = this.$t("builder.parts.details.at");

      if (interval.source === "ITEM_AGE_MONTHS")
        postfix = this.$t("builder.parts.details.months");
      else if (interval.source === "ENGINE_HOURS")
        postfix = this.$t("builder.parts.details.hours");
      else if (interval.source === "SAILING_HOURS")
        postfix = this.$t("builder.parts.details.hours");
      else if (interval.source === "RUNNING_HOURS")
        postfix = this.$t("builder.parts.details.hours");
      else if (interval.source === "MILEAGE")
        postfix = this.$t("builder.parts.details.nm");
      // let postfix = interval.source === "ITEM_AGE_MONTHS" ? "months" : "hours";
      return `${source} ${periodic} ${interval.value} ` + postfix;
    },
  },
};
</script>
<style scoped></style>
